import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTE_ACCOUNT_SETTINGS } from '../../../../../../constants/routes';

export function IncompleteProfileState() {
  const navigate = useNavigate();
  return (
    <Result
      status="warning"
      title="Complete your business profile"
      subTitle="The Accounting hub needs a few details about your business before we can show you reports."
      extra={
        <Button type="primary" onClick={() => navigate(ROUTE_ACCOUNT_SETTINGS)}>
          Complete Profile
        </Button>
      }
    />
  );
}
